import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import packageJson from '../../package.json';

const getEnv = (): string => {
  const gateWay = window['runConfig'].baseUrl;
  if (gateWay.indexOf('development') > 0) {
    return 'Dev';
  }
  if (gateWay.indexOf('Stage') > 0) {
    return 'Stage';
  }
  if (gateWay.indexOf('uat') > 0) {
    return 'UAT';
  }
  if (gateWay.indexOf('production') > 0) {
    return 'Prod';
  }
  return 'Unknown';
};

const useDatadogRum = (): void => {
  useEffect(() => {
    const appEnv = getEnv();
    if (appEnv === 'Prod' || appEnv === 'UAT') {
      datadogRum.init({
        applicationId: process.env.REACT_APP_DATADOG_APP_ID!,
        clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN!,
        site: 'datadoghq.com',
        service: process.env.REACT_APP_DATADOG_SERVICE,
        version: packageJson.version,
        env: appEnv,
        sampleRate: 100,
        sessionReplaySampleRate: 20,
        trackInteractions: true,
        trackFrustrations: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
      });

      datadogRum.startSessionReplayRecording();
    }
  }, []);
};

export default useDatadogRum;
